<template>
  <div v-if="isVisible" class="custom-modal" @click="handleClickOutside">
    <div class="modal-content" ref="modalContent">
      <button class="close-button" @click="close">&times;</button>
      <div class="modal-body text-center">
        <p class="text-danger font-weight-bold" style="margin-top: 5%; font-size: 30px">
          Sua licença do TAGSELL expira em breve
        </p>
        <p style="margin-top: 5%; font-size: 20px">
          Renove sua licença clicando no número abaixo
          <br>
          <a target="_blank" class="text-underline text-danger" href="https://wa.me/+5511973358481">(11) 97335-8481</a>
        </p>
        <p class="text-uppercase font-weight-bold" style="margin-top: 5%; font-size: 15px">
          Sua licença expira em:
        </p>
        <div class="text-danger font-weight-bold d-flex d-flex justify-content-center align-items-center"
             style="margin-top: 5%;">
          <span style="font-size: 80px">{{ licenseDaysToExpires }}</span>
          <span class="ml-2" style="font-size: 30px">dia(s)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'license-info-modal',

  props: {
    licenseDaysToExpires: {
      required: true,
      type: Number,
    },
    showModal: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    isVisible: false,
  }),

  methods: {
    close() {
      this.isVisible = false;
    },
    handleClickOutside(event) {
      const modalContent = this.$refs.modalContent;
      if (modalContent && !modalContent.contains(event.target)) {
        this.close();
      }
    }
  },
  watch: {
    showModal(value) {
      console.log(value)
      this.isVisible = value;
    },
    isVisible(value) {
      if (value) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.custom-modal {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  width: 80%;
  max-width: 700px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/LicenseInfoModal.vue